import pathToRegexp from 'path-to-regexp'
import cloneDeep from 'lodash/cloneDeep'
import routeConfigs from '../../config/route.config'
import routeConfigsV2 from '../../config/route_v2.config'
import { isNewLayout } from './utils'

/**
 * 递归查找路由树中指定name的节点
 * @param {Array} routes 路由数组
 * @param {string} targetName 要查找的name值
 * @returns {Object|null} 找到的节点对象或null
 */
function findRouteByName(routes: any[], targetName: string) {
  // 遍历路由数组
  for (const route of routes) {
    // 检查当前节点是否匹配
    if (route.name === targetName) {
      return route
    }
    // 如果有子节点则递归查找
    if (route.children && route.children.length > 0) {
      const found = findRouteByName(route.children, targetName)
      if (found) return found
    }
  }
  return null // 未找到返回null
}

// 匹配路由
export const matchParamsPath = (pathname, breadcrumbNameMap = {}) => {
  const pathKey = Object.keys(breadcrumbNameMap).find((key) => pathToRegexp(key).test(pathname))
  return breadcrumbNameMap[pathKey]
}

// 获取第一个路由
export const getFirstRoute = (menu) => {
  const firstRoute = (menu && menu[0]) || {}
  if (firstRoute && firstRoute.children && firstRoute.children.length) {
    return getFirstRoute(firstRoute.children)
  }
  return firstRoute || {}
}

// 获取子路由
export const getRoutesByPath = (path) => {
  const route =
    (isNewLayout ? routeConfigsV2 : routeConfigs).find((route) => {
      return route.path === path
    }) || {}
  return route.routes || []
}

// 格式化 route 数据,子路由 若不存在权限字段，则继承 父路由
export const formatRoute = (data, parent = {}) => {
  return data
    .map((route) => {
      // 过滤 非菜单路由
      if (route.redirect || !route.path) {
        return null
      }

      // 避免修改 route 引用
      let item = route

      item = {
        ...item,
        key: item.path,
        name: item.name || parent.name,
        hideHeader: item.hideHeader || parent.hideHeader,
        hideInMenu: item.hideInMenu || parent.hideInMenu,
        hidePlatform: item.hidePlatform || parent.hidePlatform,
      }

      if (item.routes && item.routes.length) {
        item.children = formatRoute(item.routes, item)
      }
      // if(!isNewLayout){
      delete item.routes
      // }
      return item
    })
    .filter((item) => item) // 过滤为null的情况
}

// 过滤菜单路由
export const filterMenuData = (menuData, user, features = {}) => {
  const { is_admin, page_permit } = user || {}
  const { checked = [] } = page_permit?.checkedKeys || {}

  if (!menuData) {
    return []
  }
  const hasOldCase = checked.includes('/case')
  const noNewCase = !checked.includes('/case/approve') && !checked.includes('/case/dialog')
  const data = menuData
    .filter((item) => {
      const { name, hideInMenu, path } = item
      // 隐藏子菜单
      if (!name || hideInMenu || (Object.keys(features).length !== 0 && !features[path])) {
        // if (!name || hideInMenu) {
        return false
      }
      const hasCasePermit =
        hasOldCase && noNewCase && ['/case/approve', '/case/dialog'].includes(path)

      const hasPermit =
        !is_admin &&
        (hasCasePermit ||
          checked?.some((key: string) => {
            /**——————————————旧布局—————临时解决一些查看编辑权限勾选后，就有质检会话的问题，后续山吹---start———————————————————***/ 
            if(path==='/dialog'){
              return ['/dialog/history', '/dialog/list'].includes(key)
            }
            /**——————————————旧布局—————临时解决一些查看编辑权限勾选后，就有质检会话的问题，后续山吹---end———————————————————***/ 

            return pathToRegexp(path, [], { end: false }).test(key)
          }))

      return is_admin || hasPermit
    })
    .map((item) => {
      if (item.children) {
        item.children = filterMenuData(item.children, user, features)
      }
      return item
    })
  return data
}

// 获取面包屑映射
export const getBreadcrumbMap = (menuData) => {
  const routerMap = {}

  const flattenMenuData = (data) => {
    data.forEach((menuItem) => {
      routerMap[menuItem.path] = menuItem

      if (menuItem.children) {
        flattenMenuData(menuItem.children)
      }
    })
  }
  flattenMenuData(menuData)
  return routerMap
}

// 获取路由映射
export const getRouterMap = (routes) => {
  const routerMap = {}

  const flattenMenuData = (data, parent = {}) => {
    data.forEach((menuItem) => {
      routerMap[menuItem.path] = { ...menuItem }
      if (menuItem.routes) {
        flattenMenuData(menuItem.routes, routerMap[menuItem.path])
      }
    })
  }
  flattenMenuData(routes)
  return routerMap
}

// 获取 menuModel state
export const routes = getRoutesByPath('/')

const routeData = formatRoute(cloneDeep(routes))
export const breadcrumbs = getBreadcrumbMap(cloneDeep(routeData))
// 放入dataforce的页面
export const getRoutes = (xdata: any, filterPaths: any) => {
  /**旧布局————————删除start——————————****/ 
  // 后续删除下面保留上面
  const result = cloneDeep(
    routeData.filter((item: any) => !item.hideInMenu && !filterPaths.includes(item.path))
  )
  /**旧布局——————————删除end————————****/
  if (xdata.length <= 0) return result

  if (isNewLayout) {
    /** ——————————start  告警大屏放置  ——————————————**/
    const groupMonitor = xdata.find((i: any) => i.name === '集团监控') || {}
    // 集团监控的路由配置
    const groupMonitorPageChildren = result
      .find((i: any) => i.name === '工作台')
      .children.find((i: any) => i.name === '集团监控')
    // 自助报表的路由index
    const alertIndex = groupMonitorPageChildren.children?.findIndex(
      (item) => item.name === '自助报表'
    )
    if (alertIndex !== -1 && groupMonitor?.routes?.length) {
      // 把告警大屏放在自助报表前面
      groupMonitorPageChildren.children?.splice(alertIndex, 0, ...groupMonitor.routes)
    }
    /** ——————————end  告警大屏放置  ——————————————**/

    /** ——————————start  质检分析放置  ——————————————**/
    const qcAnalysis = xdata.find((i: any) => i.name === '质检分析')
    // 质检分析的路由配置
    const qcAnalysisPageChildren = findRouteByName(result, '质检分析')
    if (qcAnalysis?.routes?.length) {
      //  两个dataforce页面直接放在最后，所以push进去就行

      qcAnalysisPageChildren.children?.push(...qcAnalysis.routes)
    }
    /** ——————————start  质检分析放置  ——————————————**/

    /** ——————————start  实时风险分析放置  ——————————————**/
    const riskAnalysis = xdata.find((i: any) => i.name === '实时风险分析')
    const riskAnalysisSort = [
      '实时会话监控',
      '实时告警报表',
      '组长实时监控',
      '平台告警统计',
      '店铺实时告警',
      '全局告警统计',
    ]
    // 实时风险分析的路由配置
    const riskAnalysisPageChildren = findRouteByName(result, '实时风险分析')
    if (riskAnalysis?.routes?.length) {
      //  两个dataforce页面直接放在最后，所以push进去就行
      riskAnalysisPageChildren.children?.push(...riskAnalysis.routes)
      // 排一下顺序
      riskAnalysisPageChildren.children = riskAnalysisSort.map((item) => {
        return riskAnalysisPageChildren.children.find((i: any) => i.name === item)
      })
    }
    /** ——————————end  实时风险分析放置  ——————————————**/

    /** ——————————start  客服评价满意度放置  ——————————————**/
    const customerService = xdata.find((i: any) => i.name === '客服评价满意度')
    const serviceAnalysis = result.find((i: any) => i.name === '服务分析')

    if (customerService?.routes?.length) {
      //  两个dataforce页面直接放在最前面，所以push进去就行
      serviceAnalysis.children = [...customerService.routes, ...serviceAnalysis.children]
    }
    /** ——————————end 客服评价满意度放置  ——————————————**/

    /** ——————————start  商品咨询热点放置  ——————————————**/
    const vocHot = xdata.find((i: any) => i.name === '商品咨询热点')
    const vocHotPageChild = findRouteByName(result, '商品咨询热点')
    if (vocHot?.routes?.length) {
      //  两个dataforce页面直接放在最前面
      vocHotPageChild.children = [...vocHot.routes, ...vocHotPageChild.children]
    }
    /** ——————————end  商品咨询热点放置  ——————————————**/

    /** ——————————start  商品流失分析放置  ——————————————**/
    const vocLost = xdata.find((i: any) => i.name === '商品流失分析')
    const vocLostPageChild = findRouteByName(result, '商品流失分析')
    if (vocLost?.routes?.length) {
      //  两个dataforce页面直接放在最前面
      vocLostPageChild.children = [...vocLost.routes, ...vocLostPageChild.children]
    }
    /** ——————————end  商品流失报告放置  ——————————————**/

    /** ——————————start  人工质检放置  ——————————————**/
    const check = xdata.find((i: any) => i.name === '人工质检')
    const checkPageChild = findRouteByName(result, '人工质检')
    if (check?.routes?.length) {
      //  两个dataforce页面直接放在最前面
      checkPageChild.children = [...check.routes, ...checkPageChild.children]
    }
    /** ——————————end  人工质检放置  ——————————————**/

    // 旧布局-旧布局的路由处理逻辑（后续删除 - 删除start）
  } else {
    const dataPage = xdata.find((i: any) => i.name === '数据监控')

    if (dataPage?.routes) {
      // 把"质检诊断报告"放在第二项
      const secondPagePath = '/data/62f249e50c010945e7c03289'
      const dataPageChildren = result.find((i: any) => i.name === '数据监控')
      dataPageChildren?.children?.splice(
        1,
        0,
        ...dataPage.routes.filter((i) => i.path === secondPagePath)
      )
      dataPageChildren?.children?.push(...dataPage.routes.filter((i) => i.path !== secondPagePath))
    }

    const meidiPage1 = xdata.find((i: any) => i.id === '64cb196b544b90b1e25151f1')

    if (meidiPage1?.routes) {
      const dataPageChildren = result.find((i: any) => i.path === '/meidi')
      dataPageChildren?.children?.push(...meidiPage1.routes)
    }

    const meidiPage2 = xdata.find((i: any) => i.id === '65ae2331caedb3e32d0b0651')

    if (meidiPage2?.routes) {
      const dataPageChildren = result.find((i: any) => i.path === '/meidi2')
      dataPageChildren?.children?.push(...meidiPage2.routes)
    }

    const pddReportsPage = xdata.find((i: any) => i.id === '660117d78b749bc0065b6360')

    if (pddReportsPage?.routes) {
      const dataPageChildren = result.find((i: any) => i.path === '/pddReports')
      dataPageChildren?.children?.push(...pddReportsPage.routes)
    }

    const vocPage = xdata.find((i: any) => i.name === '消费者分析')

    if (vocPage?.routes) {
      const dataPageChildren = result.find((i: any) => i.name === 'VOC')
      dataPageChildren?.children?.map((v) => {
        if (v.name === '商品咨询热点') {
          v.children = [
            ...vocPage?.routes?.filter((i) => i.path.startsWith('/voc/hot')),
            ...v.children,
          ]
        }
        if (v.name === '商品流失分析') {
          v.children = [
            ...vocPage?.routes?.filter((i) => i.path.startsWith('/voc/analysis')),
            ...v.children,
          ]
        }
        return v
      })
    }

    // splice(x, x, x)手动插入路由位置，老前辈的代码...，若修改了路由结构，可能导致bug
    const qcTablePage = xdata.find((i: any) => i.name === '质检报表')
    if (qcTablePage?.routes) {
      const dataPageChildren = result.filter((i: any) => i.name === '质检报表')[1]

      dataPageChildren?.children?.splice(0, 0, ...qcTablePage.routes)
    }

    const mydPage = xdata.find((i: any) => i.name === '满意度')

    if (mydPage) {
      const addMenu = {
        name: mydPage.routes[0].name,
        icon: 'iconfile-list-2-line',
        path: `/${mydPage.id}/${mydPage.routes[0].id}`,
      }

      result.splice(result.length - 7, 0, addMenu)
      if (mydPage.routes[1]) {
        const addMenuJd = {
          name: mydPage.routes[0].name,
          icon: 'iconfile-list-2-line',
          path: `/${mydPage.id}/${mydPage.routes[1].id}`,
        }
        result.splice(result.length - 6, 0, addMenuJd)
      }
    }
    const alertPage = xdata.find((i: any) => i.name === '实时告警')
    if (alertPage) {
      const addMenu = {
        name: alertPage.name,
        icon: 'iconshishigaojing',
        path: `/${alertPage.id}`,
        children: alertPage.routes,
      }
      const index = result.findIndex((item) => item.name === '基础管理')
      result.splice(index, 0, addMenu)
    }
    // 旧布局-旧布局的路由处理逻辑（后续删除 - 删除end）
  }
  return result
}

export const getMenuState = (
  user: any,
  xdata: any[],
  features: any,
  filterPaths: string[] = []
) => {
  const routeMap = getRouterMap(routes)
  // 添加实时告警
  const routeDataCopy = getRoutes(xdata, filterPaths)
  const menus = filterMenuData(routeDataCopy, user, features).filter((item) => {
    const { path, redirect, children } = item
    if(isNewLayout){
    return (path && !redirect && children?.length) || (children && children.length)
    }
    return (path && !redirect) || (children && children.length)
  })
  const firstRoute = getFirstRoute(menus)
  return { menus, breadcrumbs, routes: routeMap, firstRoute }
}

export const getCount = (m: string, mixed: string[]) => {
  let count = 0
  mixed.forEach((item) => {
    if (`/${item.split('/')[1]}` === m) {
      count += 1
    }
  })
  return count
}

export const getRoleAuthData = (roleData: any) => {
  const level: string[] = []
  const result = {}
  // 筛出第一层级
  roleData.forEach((item) => {
    if (!item.split('/')[2]) {
      level.push(`/${item.split('/')[1]}`)
    }
  })
  // 求差集
  const mixed = roleData.filter((item) => level.indexOf(item) === -1)
  // 在mixed中找到以level开头的孩子的数量
  let num = 0
  level.forEach((m) => {
    num = getCount(m, mixed)
    result[m] = num
  })
  return result
}

export const getFinallyResult = (data: any, roleAuthData: any, mapData: any) => {
  Object.getOwnPropertyNames(roleAuthData).forEach((key1) => {
    Object.getOwnPropertyNames(mapData).forEach((key2) => {
      if (key1 === key2) {
        if (
          key1 === '/dialog' &&
          Object.keys(data).includes('/dialog/radar') &&
          roleAuthData[key1] === 2
        ) {
          delete data[key1]
        } else if (roleAuthData[key1] !== mapData[key2].children.length) {
          // 每一层级子级的个数不等于参照数据的children的个数
          delete data[key1]
        }
      }
    })
  })
  return data
}

export const getAllRoutes = (roleAuth: any, xdata: any, filterPaths: any) => {
  const data = cloneDeep(roleAuth)
  const roleAuthData = getRoleAuthData(Object.keys(data)) // 求出第一层级子级的个数
  const { menus } = getMenuState({ is_admin: true }, xdata, {}, filterPaths)
  const mapData = getRouterMap(menus) // 获取菜单（标准）
  const result = getFinallyResult(data, roleAuthData, mapData) // 将求出的每一层级的子级个数同标准进行对比，求出最终的结果
  return Object.keys(result)
}
